import { RouteComponentProps } from 'react-router-dom'

import get from 'lodash/get'
import set from 'lodash/set'
import isNil from 'lodash/isNil'

export const getUrl = () =>
  process.env.NODE_ENV !== 'production'
    ? process.env.REACT_APP_API_URL_LOCAL
    : process.env.REACT_APP_API_URL

export const getApiUrl = () => `${getUrl()}/graphql`

export const normalizeToken = (token: string) => {
  if (!String(token).startsWith('Bearer ')) {
    return `Bearer ${token}`
  }

  return String(token)
}

export const getPrintTemplateLink = (name: string, args: { [k: string]: string | number }) => {
  const token = get(args, 'token')

  // Normalize the token
  if (!isNil(token)) {
    set(args, 'token', normalizeToken(String(token)))
  }

  const getQueryParams = (args: { [k: string]: string | number }) => {
    return (
      '?' +
      Object.keys(args)
        .map((key) => `${key}=${String(args[key])}`)
        .join('&')
    )
  }

  return `${getUrl()}/exports/${name}${getQueryParams(args)}`
}

export const parseNumber = (value?: string, unit?: string) => {
  if (isNil(value)) {
    return ''
  }

  return parseFloat(value).toFixed(getFractionDigit(unit))
}

export const formatNumber = (value: string | number | undefined, unit?: string) => {
  value = !isNil(value) ? value : 0

  if (unit && unit.includes('EUR')) {
    unit = 'EUR'
  }

  return Number(value).toLocaleString('de-DE', {
    minimumFractionDigits: getFractionDigit(unit),
    maximumFractionDigits: getFractionDigit(unit),
  })
}

export const getFractionDigit = (unit: string | undefined) => {
  switch (unit) {
    case '%':
      return 2
    case 'm²':
    case 'm2':
      return 2
    case 'm':
    case 'm1':
      return 3
    case 'mm':
      return 1
    case 'Stk':
    case 'Stk.':
      return 3
    case 'kg':
      return 3
    case 'h':
      return 3
    case 'EUR':
      return 2
    default:
      return 0
  }
}

export const formatUnit = (unit: string) => {
  if (!unit) {
    return ''
  }

  switch (unit) {
    case 'm1':
      return 'm'
    case 'm2':
      return 'm²'
    case 'Stk':
    case 'Stk.':
      return 'St'
    default:
      return unit
  }
}

export const getProjectId = (props: RouteComponentProps<any>) => {
  const { projectId } = props.match.params
  return projectId
}

export const getProjectNumber = (projectNumber: string) => {
  const doTruncate = projectNumber.indexOf('-aRx-') > 0

  if (doTruncate) {
    return projectNumber.split('-aRx-').pop()
  }

  return projectNumber
}

export const isExternalUrl = (url: string) => {
  if (!url.includes('http://') && !url.includes('https://')) {
    return false
  }

  const domain = (url: string) => {
    return url.replace('http://', '').replace('https://', '').split('/')[0]
  }

  return domain(window.location.href) !== domain(url)
}

export const getManufacturer = () => {
  if (process.env.REACT_APP_ENV === 'rigips') {
    return process.env.REACT_APP_DB_NAME || null
  }

  return localStorage.getItem('manufacturer')
}

export const setManufacturer = (manufacturerId: string) => {
  return localStorage.setItem('manufacturer', manufacturerId)
}
